// extracted by mini-css-extract-plugin
export default {"feature":"Feature_feature__KKSdr","icon":"Feature_icon__fa0EA"};